<template>
  <v-row>
    <v-col md="8" offset-md="2" xl="6" offset-xl="3">
      <v-alert v-if="message" border="left" type="success" elevation="2">
        {{ message }}
      </v-alert>
      <BaseBlock title="Mon profil">
        <v-form v-model="valid" ref="form">
          <BaseAlert :error="error" />
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="etudiant.nom"
                label="Nom *"
                @input="resetApiErrors('nom')"
                :error-messages="checkApiErrors('nom')"
                :rules="nomRules"
                :readonly="etudiant.uid > 0"
                :filled="etudiant.uid > 0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="etudiant.prenom"
                label="Prénom *"
                @input="resetApiErrors('prenom')"
                :error-messages="checkApiErrors('prenom')"
                :rules="prenomRules"
                :readonly="etudiant.uid > 0"
                :filled="etudiant.uid > 0"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-menu
                v-model="showCalendar"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatedDate"
                    label="Date de naissance *"
                    prepend-icon="event"
                    readonly
                    clearable
                    v-on="on"
                    autofocus
                    :rules="dateNaissanceRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="fr-fr"
                  :min="minDateNaissance"
                  :max="maxDateNaissance"
                  :showCurrent="maxDateNaissance"
                  v-model="etudiant.dateNaissance"
                  @input="showCalendar = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4" offset="0" offset-md="2">
              <v-text-field
                v-model="etudiant.ine"
                label="INE / BEA *"
                @input="resetApiErrors('ine')"
                :error-messages="checkApiErrors('ine')"
                :rules="ineRules"
                :filled="etudiant.uid > 0"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                v-model="etudiant.idBacSerie"
                label="Série baccalauréat ou diplôme équivalent *"
                :items="seriesBac"
                item-value="id"
                item-text="libelle"
                :rules="serieBacRules"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="etudiant.anneeBac"
                label="Année d'obtention *"
                @input="resetApiErrors('anneeBac')"
                :error-messages="checkApiErrors('anneeBac')"
                :rules="anneeRules"
              ></v-text-field> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="etudiant.etabSemestre1"
                label="Etablissement actuellement fréquenté *"
                @input="resetApiErrors('etabSemestre1')"
                :error-messages="checkApiErrors('etabSemestre1')"
                :rules="etabSemestre1Rules"
                :readonly="etudiant.uid > 0"
                :filled="etudiant.uid > 0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="etudiant.idNiveauFormation"
                label="Niveau d'études actuel *"
                :items="niveaux"
                item-value="id"
                item-text="libelle"
                :rules="niveauRules"
                @change="resetFormationSemestre1Udl"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="etudiant.uid > 0">
              <v-select
                v-if="etudiant.idNiveauFormation"
                v-model="etudiant.idFormationSemestre1Udl"
                label="Formation actuellement suivie *"
                :items="formationsDuNiveau"
                item-value="id"
                item-text="libelle"
                :rules="formationSemestre1Rules"
              >
              </v-select>
            </v-col>
            <v-col cols="12" v-else>
              <v-text-field
                v-model="etudiant.formationSemestre1"
                label="Libellé formation actuellement suivie *"
                @input="resetApiErrors('formationSemestre1')"
                :error-messages="checkApiErrors('formationSemestre1')"
                :rules="formationSemestre1Rules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <EditCursusPostBac
                v-model="cursusPostBac"
                :maxRows="maxOccurrencesCursus"
                @validRow="validCursusPostBac"
              >
              </EditCursusPostBac>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="font-weight-light">Adresse</v-col>
          </v-row>
          <v-row>
            <v-col cols="10" offset="2">
              <v-text-field
                v-model="etudiant.addrNoRue"
                label="N°, Rue *"
                @input="resetApiErrors('addrNoRue')"
                :error-messages="checkApiErrors('addrNoRue')"
                autofocus
                :rules="addrNoRueRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" md="5" offset="2">
              <v-text-field
                v-model="etudiant.addrCp"
                label="Code postal *"
                @input="resetApiErrors('addrCp')"
                :error-messages="checkApiErrors('addrCp')"
                :rules="addrCpRules"
              ></v-text-field>
            </v-col>
            <v-col cols="10" md="5" offset="2" offset-md="0">
              <v-text-field
                v-model="etudiant.addrVille"
                label="Ville *"
                @input="resetApiErrors('addrVille')"
                :error-messages="checkApiErrors('addrVille')"
                :rules="addrVilleRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" md="5" offset="2">
              <v-text-field
                v-model="etudiant.addrPays"
                label="Pays *"
                @input="resetApiErrors('addrPays')"
                :error-messages="checkApiErrors('addrPays')"
                :rules="addrPaysRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="etudiant.telephone"
                label="Téléphone *"
                @input="resetApiErrors('telephone')"
                :error-messages="checkApiErrors('telephone')"
                :rules="telephoneRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                class="mt-n2"
                v-model="etudiant.mail"
                label="Email"
                readonly
                filled
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="text-center">
                <v-btn
                  class="mx-2"
                  :disabled="!valid || !validPostBac"
                  color="primary"
                  @click="enregistrer"
                  :loading="loading"
                >
                  <v-icon left>save</v-icon>Enregistrer
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import moment from "moment";
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
import { mapState } from "vuex";
import EditCursusPostBac from "@/components/EditCursusPostBac";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiParametrageRepository from "@/repositories/ApiParametrageRepository";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "FormProfil",
  components: { BaseBlock, EditCursusPostBac, BaseAlert },
  extends: BaseForm,
  data() {
    return {
      etudiant: {
        id: "",
        uid: 0,
        nom: "",
        prenom: "",
        dateNaissance: "",
        mail: "",
        ine: "",
        addrNoRue: "",
        addrCp: "",
        addrVille: "",
        addrPays: "",
        idBacSerie: "",
        anneeBac: "",
        cursusPostbac: [],
        formationSemestre1: "",
        idFormationSemestre1Udl: 0,
        etabSemestre1: "",
        telephone: "",
        idNiveauFormation: "",
      },
      onglets: null,
      showCalendar: false,
      message: null,
      loading: false,
      seriesBac: [],
      formations: [],
      niveaux: [],
      cursusPostBac: [],
      occurrenceCursus: {
        id: null,
        anneeUniv: 0,
        libelleAnneeUniv: "",
        cursus: "",
        niveau: "",
        validation: false,
        etablissement: "",
      },
      maxOccurrencesCursus: 3,
      validPostBac: true,
      nomRules: [
        (v) =>
          (v && v.length >= 2) ||
          "Le nom doit contenir au minimum 2 caractères",
      ],
      prenomRules: [
        (v) =>
          (v && v.length >= 2) ||
          "Le prénom doit contenir au minimum 2 caractères",
      ],
      dateNaissanceRules: [
        (v) => !!v || "La date de naissance doit être renseignée",
      ],
      ineRules: [
        //v => (v && v.length == 11) || "L'INE' doit contenir 11 caractères"
        (v) => !!v || "L'INE / BEA' doit être renseigné",
      ],
      serieBacRules: [(v) => !!v || "Le bac ou équivalence est requis"],
      anneeRules: [
        (v) =>
          (/^(19|20){1}[0-9]{2}$/.test(v) &&
            !isNaN(v) &&
            this.minAnneeBac <= v &&
            v <= this.maxAnneeBac) ||
          "L'année (sur 4 chiffres) n'est pas valide",
      ],
      formationSemestre1Rules: [
        (v) => !!v || "La formation doit être renseignée",
      ],
      niveauRules: [(v) => !!v || "Le niveau d'études est requis"],
      etabSemestre1Rules: [(v) => !!v || "L'établissement doit être renseigné"],
      addrNoRueRules: [(v) => !!v || "Le n°, rue doit être renseigné"],
      addrCpRules: [
        (v) => /^[0-9]{5}$/.test(v) || "Le code postal n'est pas valide",
      ],
      addrVilleRules: [(v) => !!v || "La ville doit être renseignée"],
      addrPaysRules: [(v) => !!v || "Le pays doit être renseigné"],
      telephoneRules: [
        (v) =>
          /^(0|\+33)[1-9][0-9]{8}$/.test(v) || "Le téléphone n'est pas valide",
      ],
      nouvelEtudiant: true,
      parametrage: {},
    };
  },
  computed: {
    ...mapState(["user"]),
    formatedDate: {
      get() {
        return this.etudiant.dateNaissance
          ? moment(this.etudiant.dateNaissance).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.etudiant.dateNaissance = value;
      },
    },
    minDateNaissance() {
      return moment().subtract(100, "years").format("YYYY-MM-DD");
    },
    maxDateNaissance() {
      return moment().subtract(10, "years").format("YYYY-MM-DD");
    },
    minAnneeBac() {
      return moment().subtract(90, "years").format("YYYY");
    },
    maxAnneeBac() {
      return moment().format("MM") > 8
        ? moment().format("YYYY")
        : moment().subtract(1, "years").format("YYYY");
    },
    idRefNiveau() {
      return this.etudiant.idNiveauFormation === 3 // si chevauchement => formations 2ème année
        ? 2
        : this.etudiant.idNiveauFormation;
    },
    formationsDuNiveau() {
      return this.getFormationsNiveau(this.idRefNiveau);
    },
  },
  async created() {
    await this.getParametrage();
    await this.getSeriesBac();
    await this.getNiveauxEtude();
    await this.getEtudiant();
    if (this.etudiant.uid > 0) {
      await this.getFormations();
    }
    this.initEditionCursusPostBac();
    if (this.parametrage.campagnePrecoce && !this.etudiant.idNiveauFormation) {
      this.etudiant.idNiveauFormation = this.niveaux[0].id; // 1 => Première année
    }
  },
  methods: {
    async getParametrage() {
      try {
        const parametrage = await ApiParametrageRepository.getParametrage(
          this.parametrage
        );

        this.parametrage = parametrage;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getSeriesBac() {
      try {
        const seriesBac = await ApiEtudiantRepository.getSeriesBac();
        this.seriesBac = seriesBac;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async getFormations() {
      try {
        const formations = await ApiFormationRepository.getFormations();
        this.formations = formations;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async getNiveauxEtude() {
      try {
        const niveaux = await ApiEtudiantRepository.getNiveauxEtude();
        this.niveaux = niveaux;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async getEtudiant() {
      try {
        const etudiant = await ApiEtudiantRepository.getEtudiant();
        this.etudiant = etudiant;
        this.$refs.form.resetValidation();
        if (
          Object.prototype.hasOwnProperty.call(etudiant, "uid") ||
          Object.prototype.hasOwnProperty.call(etudiant, "dateNaissance")
        ) {
          this.nouvelEtudiant = false;
        }
      } catch (error) {
        if (error.response) {
          if (error.response.data.status === 404) {
            try {
              this.etudiant = await this.getUserAttributes();
              this.etudiant.etabSemestre1 = "Université de Lille";
              this.etudiant.id = null;
              this.$refs.form.resetValidation();
            } catch (error) {
              this.populateErrors(error);
            }
          } else {
            this.populateErrors(error);
          }
        }
      }
    },
    async getUserAttributes() {
      let etudiant = await ApiEtudiantRepository.getUserAttributes();
      return etudiant;
    },
    async enregistrer() {
      this.loading = true;
      try {
        this.etudiant = await this.setEtudiant(this.user.id, this.etudiant);
        if (this.nouvelEtudiant) {
          if (!this.parametrage.campagnePrecoce) {
            this.user.roles.push("ROLE_CAMPAGNE_NORMALE");
          }
          this.user.roles.push("ROLE_ETUDIANT");
          if (this.user.roles.indexOf("ROLE_CAMPAGNE_NORMALE") > -1) {
            this.$router.push({ name: "inscriptionAtelier" });
          } else {
            this.$router.push({ name: "mes-candidatures" });
          }
          this.$toast.success("Le profil a été enregistré");
        } else {
          this.$toast.success("Le profil a été mis à jour");
        }
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loading = false;
      }
    },
    async setEtudiant(ident, etudiant) {
      etudiant.cursusPostBac = this.getCursusPostBacEpure();
      let etudiantMaj;
      if (etudiant.id > 0) {
        etudiantMaj = await ApiEtudiantRepository.updateEtudiant(etudiant);
      } else {
        etudiantMaj = await ApiEtudiantRepository.addEtudiant(etudiant);
      }
      return etudiantMaj;
    },
    anneeUnivEnCours() {
      return moment().format("MM") > 8
        ? moment().format("YYYY")
        : moment().subtract(1, "years").format("YYYY");
    },
    initOccurrenceCursus(anneeUniv) {
      let newOccurrenceCursus = JSON.parse(
        JSON.stringify(this.occurrenceCursus)
      );
      newOccurrenceCursus.anneeUniv = anneeUniv;
      newOccurrenceCursus.libelleAnneeUniv =
        "" + anneeUniv + "-" + (anneeUniv + 1);
      this.cursusPostBac.push(newOccurrenceCursus);
    },
    initEditionCursusPostBac() {
      if (!this.nouvelEtudiant) {
        this.cursusPostBac = JSON.parse(
          JSON.stringify(this.etudiant.cursusPostBac)
        );
      }
      if (this.cursusPostBac.length < this.maxOccurrencesCursus) {
        const anneeUnivEnCours = this.anneeUnivEnCours();
        for (
          let anneeUniv = anneeUnivEnCours - 1;
          anneeUniv >= anneeUnivEnCours - this.maxOccurrencesCursus;
          anneeUniv--
        ) {
          if (
            this.nouvelEtudiant ||
            (!this.nouvelEtudiant &&
              !this.etudiant.cursusPostBac.find(
                (x) => x.anneeUniv == anneeUniv
              ))
          ) {
            this.initOccurrenceCursus(anneeUniv);
          }
        }
      }
      this.cursusPostBac.sort((a, b) => b.anneeUniv - a.anneeUniv);
    },
    getCursusPostBacEpure() {
      let cursusPostBac = [];
      for (const index in this.cursusPostBac) {
        if (this.cursusPostBac[index].cursus !== "") {
          cursusPostBac.push(this.cursusPostBac[index]);
        }
      }
      return cursusPostBac;
    },
    validCursusPostBac(validPostBac) {
      this.validPostBac = validPostBac.indexOf(false) < 0 ? true : false;
    },
    getFormationsNiveau(idNiveau) {
      return this.formations.filter((f) => {
        return f.idNiveau === idNiveau;
      });
    },
    resetFormationSemestre1Udl() {
      let present = this.formationsDuNiveau.find((f) => {
        return f.id === this.etudiant.idFormationSemestre1Udl;
      });
      if (!present) {
        this.etudiant.idFormationSemestre1Udl = "";
      }
    },
  },
};
</script>
